import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCheckFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 417,
	height: 285,
	viewBox: "0 0 417 285",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 154.337C-5.57363e-05 179.434 21.0303 239.37 66.5215 265.733C112.971 292.651 151.915 270.128 206.692 271.016C248.065 271.687 273.561 283.593 312.651 271.016C367.961 253.221 427.97 222.712 415.284 169.747C406.462 132.914 364.448 133.512 338.309 104.583C312.234 75.7245 315.03 45.9308 282.716 23.1272C212.768 -26.2346 127.459 10.751 62.2451 65.3961C29.1087 93.1621 5.57365e-05 129.239 0 154.337Z",
			fill: "#FFF2F5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 219,
			cy: 72,
			r: 47,
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 78,
			cy: 76,
			rx: 78,
			ry: 76,
			transform: "matrix(-1 0 0 1 194 98)",
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 325.5,
			cy: 185,
			rx: 31.5,
			ry: 32,
			stroke: "#F2A2B5",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 126.311,
			y: 58.1877,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 126.311 58.1877)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 303.897,
			y: 107.875,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 303.897 107.875)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 148.394,
			y: 256.937,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 148.394 256.937)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 372.907,
			y: 215.531,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 372.907 215.531)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 128.205,
			y: 47.8472,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 128.205 47.8472)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 305.792,
			y: 97.5344,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 305.792 97.5344)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 150.289,
			y: 246.596,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 150.289 246.596)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 374.802,
			y: 205.19,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 374.802 205.19)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.8428 62.5732C104.306 62.737 109.496 68.0282 109.496 74.5312L109.492 74.8398C109.328 81.3034 104.037 86.4931 97.5342 86.4932L97.2256 86.4893C90.8646 86.3281 85.7374 81.2008 85.5762 74.8398L85.5723 74.5312C85.5723 67.9251 90.928 62.5695 97.5342 62.5693L97.8428 62.5732ZM93.2676 81.251C94.5011 82.0359 95.9638 82.4931 97.5342 82.4932C101.931 82.4931 105.496 78.9282 105.496 74.5312C105.496 72.961 105.04 71.4982 104.255 70.2646L93.2676 81.251ZM97.5342 66.5693C93.1372 66.5695 89.5723 70.1342 89.5723 74.5312C89.5723 76.1776 90.0727 77.707 90.9287 78.9766L101.98 67.9248C100.711 67.0687 99.1806 66.5694 97.5342 66.5693Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.953 229.118C310.417 229.282 315.606 234.573 315.606 241.076L315.603 241.385C315.439 247.848 310.147 253.038 303.645 253.038L303.336 253.034C296.975 252.873 291.848 247.746 291.687 241.385L291.683 241.076C291.683 234.47 297.038 229.114 303.645 229.114L303.953 229.118ZM299.378 247.796C300.611 248.581 302.074 249.038 303.645 249.038C308.041 249.038 311.606 245.473 311.606 241.076C311.606 239.506 311.15 238.042 310.365 236.809L299.378 247.796ZM303.645 233.114C299.248 233.114 295.683 236.679 295.683 241.076C295.683 242.722 296.183 244.252 297.039 245.521L308.091 234.47C306.821 233.614 305.291 233.114 303.645 233.114Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.344 59.2631C274.171 58.627 274.65 58 275.309 58H284.691C285.35 58 285.829 58.627 285.656 59.2631L280.965 76.4625C280.697 77.445 279.303 77.445 279.035 76.4625L274.344 59.2631Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 280,
			cy: 83,
			r: 3,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddddd_5649_528)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 69.9302,
				y: 149.806,
				width: 115.366,
				height: 72.8627,
				rx: 8,
				transform: "rotate(-8.69553 69.9302 149.806)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.72 154.97C70.2838 152.118 72.2422 149.453 75.0943 149.016L178.806 133.155C181.658 132.718 184.324 134.677 184.76 137.529L186.495 148.87L72.4546 166.312L70.72 154.97Z",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 137.97,
			y1: 190.141,
			x2: 179.113,
			y2: 183.849,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 136.211,
			y1: 178.637,
			x2: 177.354,
			y2: 172.345,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 134.452,
			y1: 167.133,
			x2: 175.594,
			y2: 160.841,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 139.73,
			y1: 201.645,
			x2: 173.37,
			y2: 196.501,
			stroke: "#EF476F",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 79.1787,
			y1: 157.159,
			x2: 108.317,
			y2: 152.703,
			stroke: "white",
			strokeWidth: 3.9181,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 80.5629,
			y: 173.197,
			width: 40.9853,
			height: 40.9853,
			rx: 3,
			transform: "rotate(-8.69553 80.5629 173.197)",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.496 199.852C110.123 198.907 108.599 197.778 108.163 194.928C107.902 193.218 109.086 191.902 109.323 190.366C109.56 188.829 109.562 187.053 109.591 185.757C109.62 184.46 109.633 183.959 109.548 182.595C109.439 180.894 107.703 176.724 101.968 177.602C96.2337 178.479 95.8204 182.977 96.228 184.632C96.5544 185.959 96.7178 186.434 97.1322 187.662C97.5467 188.891 98.0765 190.586 98.7619 191.981C99.4472 193.376 100.972 194.277 101.234 195.988C101.67 198.837 100.553 200.37 96.6622 202.579C92.7573 204.794 90.3038 206.764 90.4721 207.865L91.261 213.023L122.772 208.203L121.983 203.045C121.815 201.946 118.883 200.8 114.496 199.852Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_5649_528)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_ddddd_5649_528)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M245.874 157.278C244.927 165.133 237.792 170.734 229.937 169.788L136.939 158.581C129.084 157.635 123.483 150.5 124.429 142.645L130.229 94.5048C131.177 86.6495 138.312 81.049 146.167 81.9966L239.165 93.2015C247.02 94.1465 252.621 101.283 251.674 109.138L245.874 157.278Z",
						fill: "#F5C0CD"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.97 144.622L161.852 136.053L161.986 134.96L233.102 143.528L232.97 144.622Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.178 151.188L161.061 142.619L161.194 141.526L232.311 150.094L232.178 151.188Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.202 145.689L162.757 146.796C162.903 147.083 163.021 147.347 163.147 147.632L163.176 147.634C163.369 147.368 163.554 147.141 163.744 146.904L164.536 145.97L165.473 146.084L163.568 148.192L164.946 150.856L163.961 150.738L163.391 149.581C163.238 149.281 163.112 148.998 162.979 148.691L162.958 148.688C162.766 148.955 162.568 149.192 162.357 149.455L161.538 150.446L160.584 150.331L162.569 148.101L161.236 145.572L162.202 145.689Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.76 146.239L167.317 147.346C167.462 147.633 167.579 147.897 167.705 148.181L167.734 148.185C167.927 147.918 168.113 147.69 168.302 147.455L169.094 146.52L170.031 146.633L168.126 148.742L169.506 151.407L168.52 151.287L167.949 150.13C167.797 149.83 167.67 149.547 167.538 149.24L167.517 149.238C167.326 149.505 167.126 149.741 166.916 150.004L166.097 150.996L165.142 150.88L167.128 148.652L165.795 146.123L166.76 146.239Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M171.319 146.788L171.875 147.896C172.021 148.182 172.139 148.447 172.265 148.729L172.294 148.734C172.487 148.467 172.673 148.238 172.862 148.005L173.654 147.07L174.59 147.183L172.686 149.291L174.065 151.957L173.079 151.837L172.509 150.679C172.356 150.38 172.23 150.097 172.097 149.79L172.076 149.788C171.885 150.053 171.686 150.291 171.475 150.553L170.656 151.544L169.702 151.429L171.688 149.2L170.354 146.671L171.319 146.788Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M175.879 147.338L176.434 148.444C176.581 148.732 176.698 148.995 176.824 149.279L176.853 149.283C177.046 149.018 177.232 148.789 177.421 148.553L178.213 147.619L179.15 147.731L177.247 149.841L178.625 152.506L177.639 152.387L177.068 151.228C176.915 150.93 176.79 150.645 176.656 150.339L176.636 150.337C176.445 150.603 176.247 150.839 176.034 151.103L175.216 152.094L174.261 151.979L176.247 149.75L174.914 147.221L175.879 147.338Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.437 147.886L180.994 148.992C181.139 149.28 181.256 149.544 181.382 149.829L181.411 149.832C181.604 149.566 181.792 149.338 181.979 149.103L182.772 148.168L183.708 148.28L181.805 150.389L183.183 153.055L182.199 152.937L181.628 151.778C181.474 151.478 181.349 151.195 181.216 150.889L181.195 150.886C181.004 151.152 180.805 151.388 180.593 151.653L179.774 152.643L178.819 152.527L180.806 150.3L179.473 147.769L180.437 147.886Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.996 148.436L185.553 149.542C185.697 149.83 185.817 150.094 185.943 150.378L185.971 150.381C186.164 150.116 186.349 149.888 186.54 149.651L187.331 148.717L188.267 148.83L186.363 150.938L187.741 153.603L186.756 153.485L186.187 152.326C186.033 152.028 185.907 151.743 185.775 151.438L185.754 151.435C185.562 151.701 185.364 151.938 185.152 152.202L184.333 153.192L183.379 153.077L185.365 150.85L184.032 148.319L184.996 148.436Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M190.888 150.956L190.811 151.594L188.377 151.303L188.455 150.661L190.888 150.956Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.52 149.342L193.077 150.449C193.223 150.736 193.339 151 193.465 151.285L193.494 151.287C193.687 151.022 193.875 150.794 194.063 150.559L194.854 149.623L195.791 149.736L193.888 151.845L195.266 154.511L194.28 154.392L193.709 153.233C193.557 152.935 193.431 152.65 193.297 152.344L193.278 152.341C193.086 152.608 192.888 152.844 192.675 153.108L191.858 154.099L190.902 153.983L192.889 151.756L191.554 149.226L192.52 149.342Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M197.078 149.892L197.635 150.998C197.781 151.286 197.899 151.55 198.025 151.834L198.052 151.837C198.245 151.571 198.433 151.344 198.621 151.107L199.413 150.173L200.349 150.286L198.446 152.394L199.824 155.059L198.84 154.941L198.269 153.782C198.115 153.484 197.991 153.2 197.857 152.894L197.837 152.891C197.645 153.158 197.446 153.394 197.235 153.658L196.416 154.649L195.461 154.533L197.447 152.306L196.115 149.775L197.078 149.892Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M201.638 150.441L202.194 151.547C202.339 151.835 202.457 152.098 202.583 152.383L202.612 152.386C202.805 152.121 202.992 151.892 203.181 151.657L203.973 150.722L204.909 150.836L203.006 152.944L204.383 155.609L203.398 155.49L202.828 154.332C202.674 154.033 202.549 153.748 202.415 153.442L202.396 153.44C202.204 153.708 202.006 153.942 201.793 154.206L200.974 155.197L200.02 155.083L202.007 152.854L200.672 150.325L201.638 150.441Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M206.198 150.99L206.754 152.097C206.9 152.385 207.017 152.649 207.143 152.933L207.171 152.936C207.364 152.67 207.551 152.442 207.74 152.206L208.531 151.272L209.468 151.386L207.564 153.494L208.942 156.158L207.958 156.04L207.388 154.882C207.234 154.583 207.107 154.298 206.975 153.993L206.955 153.99C206.763 154.256 206.564 154.494 206.352 154.756L205.535 155.747L204.579 155.633L206.565 153.403L205.233 150.874L206.198 150.99Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M210.755 151.541L211.312 152.647C211.457 152.935 211.575 153.198 211.701 153.482L211.73 153.486C211.922 153.219 212.108 152.991 212.299 152.756L213.09 151.822L214.026 151.934L212.123 154.044L213.501 156.708L212.515 156.589L211.945 155.431C211.792 155.132 211.666 154.848 211.533 154.541L211.512 154.54C211.321 154.806 211.123 155.042 210.911 155.305L210.092 156.297L209.137 156.182L211.124 153.953L209.79 151.424L210.755 151.541Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M242.197 114.101C241.65 118.633 237.535 121.865 233.002 121.317L187.05 115.781C182.519 115.235 179.287 111.119 179.833 106.587C180.379 102.054 184.495 98.8238 189.029 99.3698L234.98 104.907C239.512 105.453 242.744 109.569 242.197 114.101Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M225.891 120.46L221.515 119.934L223.492 103.521L227.869 104.049L225.891 120.46Z",
					fill: "#FDE9EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.233 119.538L211.669 118.747L213.646 102.337L220.209 103.127L218.233 119.538Z",
					fill: "#FDE9EE"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 138.513,
			y: 92.2,
			width: 18.0084,
			height: 18.0084,
			rx: 2,
			transform: "rotate(6.64392 138.513 92.2)",
			fill: "#FFC73D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.04 102.257L156.243 96.0283L154.527 110.491C154.394 111.609 153.365 112.398 152.251 112.234L141.919 110.719L150.04 102.257Z",
			fill: "#FFEFC7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 138.123,
			y: 95.554,
			width: 18.0084,
			height: 1.12552,
			transform: "rotate(6.64392 138.123 95.554)",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 137.732,
			y: 98.9077,
			width: 18.0084,
			height: 1.12552,
			transform: "rotate(6.64392 137.732 98.9077)",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.9 101.458C149.612 103.928 147.877 105.755 146.025 105.54C144.173 105.324 142.904 103.147 143.192 100.677C145.707 100.97 144.694 100.852 146.546 101.068C148.398 101.283 147.804 101.214 149.9 101.458Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.912 100.21C148.624 102.68 147.39 104.565 146.155 104.421C144.92 104.278 144.153 102.159 144.44 99.6892C146.117 99.8845 145.441 99.8058 146.676 99.9497C147.911 100.094 147.515 100.047 148.912 100.21Z",
			fill: "#FFC73D"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_dddd_5649_528)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 157.578,
				y: 216.506,
				width: 156.208,
				height: 31.0384,
				transform: "rotate(-45 157.578 216.506)",
				fill: "#EF476F"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 178.31,
				y: 103.291,
				width: 161.543,
				height: 33.2244,
				transform: "rotate(45 178.31 103.291)",
				fill: "#EF476F"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ddddd_5649_528",
				x: 52.0466,
				y: 131.481,
				width: 146.823,
				height: 132.234,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1,
						dy: 5
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_528",
						result: "effect2_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -3,
						dy: 12
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_528",
						result: "effect3_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -6,
						dy: 21
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_528",
						result: "effect4_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -9,
						dy: 33
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5649_528",
						result: "effect5_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5649_528",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_5649_528",
				x: 119.101,
				y: 81.8921,
				width: 137.902,
				height: 98.448,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.22414 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.61207 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.756863 0 0 0 0 0.807843 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5649_528",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_ddddd_5649_528",
				x: 123.325,
				y: 80.8921,
				width: 136.453,
				height: 102,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1,
						dy: 2
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_528",
						result: "effect2_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 4
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_528",
						result: "effect3_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3,
						dy: 6
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_528",
						result: "effect4_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 5,
						dy: 10
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5649_528",
						result: "effect5_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5649_528",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dddd_5649_528",
				x: 144.817,
				y: 101.291,
				width: 157.721,
				height: 175.721,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.18 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_528",
						result: "effect2_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 15 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_528",
						result: "effect3_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 26 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_528",
						result: "effect4_dropShadow_5649_528"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_5649_528",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgCreditCheckFailed);
export { ForwardRef as ReactComponent };
